import { render, staticRenderFns } from "./knowledge-card.vue?vue&type=template&id=21e1ec4d&scoped=true"
import script from "./knowledge-card.vue?vue&type=script&lang=js"
export * from "./knowledge-card.vue?vue&type=script&lang=js"
import style0 from "./knowledge-card.vue?vue&type=style&index=0&id=21e1ec4d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1ec4d",
  null
  
)

export default component.exports